<template>
  <div class="col-lg-12">
    <div class="ibox light-bottom-shadow">
      <div class="ibox-title">
        <div class="d-flex justify-content-between align-items-center">
          <h5>{{ title }}</h5>

          <div class="d-flex flex-row align-items-center justify-content-end">
            <slot name="header-controls"></slot>

            <a class="collapse-link text-muted ml-2" @click="show = !show">
              <i :class="`fa ${show ? 'fa-chevron-up' : 'fa-chevron-down'} `" />
            </a>
          </div>
        </div>
      </div>

      <div
        class="ibox-content"
        :style="{ height: height }"
        v-show="show"
      >
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardTitleContent',

  components: {
  },

  props: {
    title: {
      type: String,
      required: true,
    },
    height: {
      type: String,
      default: null
    },
    startOpen: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      show: this.startOpen,
    }
  },
}
</script>
